export function enableDevTools(): void {
  if (process.env.NODE_ENV !== 'development') {
    return;
  }
}
